import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FastForwardOutlinedIcon from '@mui/icons-material/FastForwardOutlined';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Box,
  Container,
  Grid,
  Link,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useState } from 'react';

import ExemptSubMenu from '@/components/nav/ExemptSubMenu';
import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';
// import type { LayoutWrapperContents } from '@/types/LayoutWrapperContents';

const ExemptArizona = () => {
  const [open, setOpen] = useState(false);

  // const layoutWrapperContents: LayoutWrapperContents = {
  //   Heading: `Extend your business tax return deadline with Form 7004.`,
  //   SubHeading:
  //     'E-file now and get more time to ensure accuracy. File now for peace of mind.',
  //   CtaText: 'E-file Form 7004 Now',
  //   CtaSubHeading: `Takes 3 steps and less than 5 minutes`,
  //   CtaURL: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=sticky`,
  //   isActive: true,
  // };

  return (
    <AppLayout
      //  LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="Georgia Nonprofit State Filing Requirements & Deadlines"
          description="Learn about Georgia nonprofit state filing requirements, deadlines, and tax exemptions. Ensure compliance with the Secretary of State and IRS.     "
          keywords=" "
          canonical="nonprofit-taxes/georgia-state-filing-requirements/"
          jsonLdAggregateRatingValue="5.00"
          jsonLdAggregateRatingCount="2183"
          ogShareImg="assets/images/exempt-share-img.png"
        />
      }
    >
      <ExemptSubMenu />
      <ComingSoonPopup open={open} setOpen={setOpen} />

      {/* <Container maxWidth="md">
        <Box sx={{ px: 2, mt: 3, mx: 0 }}>
          <Alert
            severity="warning"
            icon={<WarningIcon sx={{ fontSize: 30 }} />}
            sx={{ borderRadius: 3 }}
          >
            <AlertTitle
              sx={{ fontSize: { xs: 18, sm: 20, md: 22 }, fontWeight: 600 }}
            >
              Attention! Final Day to E-File Form W-2!
            </AlertTitle>

            <Typography
              variant="body1"
              sx={{ fontSize: { xs: 16, sm: 17, md: 18 } }}
            >
              Don&apos;t miss the deadline! Today is the <b>Last Day</b> to
              Submit Your <b>Form W-2</b> Electronically!
            </Typography>
          </Alert>
        </Box>
      </Container> */}
      <Container maxWidth="xl" component="section">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Hidden mdDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/1099-ga-landing-img.webp" />
                <source srcSet="/assets/images/1099-ga-landing-img.png" />
                <img
                  src="/assets/images/1099-ga-landing-img.png"
                  alt="Georgia State Filing Requirements"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>

          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="div"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                <span className="highlight-container">
                  <span className="highlight">Georgia State </span>
                </span>{' '}
                Filing
                <Hidden mdDown>
                  <br />
                </Hidden>{' '}
                Requirements
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  mb: 2,
                }}
              >
                Georgia maintains specific filing requirements for non-profit
                organizations operating within the state to ensure legal
                compliance and maintain good standing.
              </Typography>

              {/* <Stack
                direction={{ xs: 'column-reverse', md: 'row' }}
                spacing={{ xs: 1, md: 6 }}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 4 }}
              >
                <Box sx={{ textAlign: 'center', mr: { xs: 0, md: 4 } }}>
                  <Button
                    variant="contained"
                    className="btn-primary"
                    sx={{
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=georgia`}
                  >
                    Get Started with TaxZerone
                  </Button>
                 
                </Box>
              </Stack> */}
            </Box>
          </Box>
          <Hidden mdUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/1099-ga-landing-img-sm.webp" />
                <source srcSet="/assets/images/1099-ga-landing-img-sm.png" />
                <img
                  src="/assets/images/1099-ga-landing-img-sm.png"
                  alt="Georgia State Filing Requirements"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Container>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ pt: 4, pb: 4 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
              fontWeight: 600,
              mb: 2,
              pt: 5,
              textAlign: 'center',
            }}
          >
            Required Non-profit Forms
          </Typography>

          <Grid container spacing={2}>
            <Grid
              size={12}
              sx={{
                px: { md: 3, sm: 0, xs: 0 },
                textAlign: 'center',
                alignItems: 'center',
              }}
            >
              <Box component="div" sx={{ mb: 5 }}>
                <TableContainer
                  sx={{ border: '1px solid #828282', borderRadius: 2 }}
                >
                  <Table sx={{}} aria-label="Due Date Chart">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#ccc' }}>
                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Secretary of State Forms
                        </TableCell>

                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Charitable Registration
                        </TableCell>
                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          State Tax Forms
                        </TableCell>
                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,

                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Federal Forms (Required for State Compliance)
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          <ul>
                            <li style={{ marginBottom: 8 }}>
                              <span style={{ fontWeight: 600 }}>
                                {' '}
                                Articles of Incorporation:
                              </span>{' '}
                              This form officially creates the nonprofit
                              corporation.
                            </li>

                            <li style={{ marginBottom: 8 }}>
                              <span style={{ fontWeight: 600 }}>
                                {' '}
                                <Link
                                  href="https://ecorp.sos.ga.gov/"
                                  target="_blank"
                                  sx={{ color: '#0202ff' }}
                                >
                                  {' '}
                                  Annual Registration/Report
                                </Link>
                                :
                              </span>{' '}
                              This annual report updates the state on the
                              organisation’s status.
                            </li>
                            <li style={{ marginBottom: 8 }}>
                              <Link
                                href="https://sos.ga.gov/sites/default/files/2022-01/c-100_initial_and_reinstatement_charity_registration_update_11.8_.2018_4.pdf"
                                target="_blank"
                                sx={{ color: '#0202ff' }}
                              >
                                <span style={{ fontWeight: 600 }}>
                                  {' '}
                                  Form C-100:
                                </span>{' '}
                                Application for State Tax Exemption
                              </Link>
                            </li>
                            <li style={{ marginBottom: 8 }}>
                              <Link
                                href="https://sos.ga.gov/sites/default/files/forms/Form%20-%20Name%20Reservation.pdf"
                                target="_blank"
                                sx={{ color: '#0202ff' }}
                              >
                                <span style={{ fontWeight: 600 }}>
                                  {' '}
                                  Form NT-01:
                                </span>{' '}
                                Name Reservation Request
                              </Link>
                            </li>
                          </ul>
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          <ul>
                            <li style={{ marginBottom: 8 }}>
                              <span style={{ fontWeight: 600 }}>
                                {' '}
                                Form C101:
                              </span>{' '}
                              Charitable Organization Registration Application
                            </li>

                            <li style={{ marginBottom: 8 }}>
                              <Link
                                href="https://sos.ga.gov/sites/default/files/2022-01/charitable_organization_renewal_notice_20190725.pdf"
                                target="_blank"
                                sx={{ color: '#0202ff' }}
                              >
                                <span style={{ fontWeight: 600 }}>
                                  {' '}
                                  Form C102:
                                </span>
                                Charitable Organization Annual Registration
                                Renewal
                              </Link>{' '}
                            </li>
                          </ul>
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          <ul>
                            <li style={{ marginBottom: 8 }}>
                              <Link
                                href="https://dor.georgia.gov/600-corporation-tax-return"
                                target="_blank"
                                sx={{ color: '#0202ff' }}
                              >
                                <span style={{ fontWeight: 600 }}>
                                  {' '}
                                  Form 600:
                                </span>{' '}
                                Georgia Corporate Tax Return
                              </Link>
                            </li>

                            <li style={{ marginBottom: 8 }}>
                              <Link
                                href="https://dol.georgia.gov/document/unemployment-tax/application-gdol-tax-account-or-status-change-dol-1n/download"
                                target="_blank"
                                sx={{ color: '#0202ff' }}
                              >
                                <span style={{ fontWeight: 600 }}>
                                  {' '}
                                  Form DOL-1:
                                </span>
                                Georgia Department of Labor Registration
                              </Link>{' '}
                            </li>
                          </ul>
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          <ul>
                            <li style={{ marginBottom: 8 }}>
                              <span style={{ fontWeight: 600 }}>
                                {' '}
                                Form 1023 (Application for Recognition of
                                Exemption Under Section 501(c)(3) of the
                                Internal Revenue Code):
                              </span>{' '}
                              For most charitable organizations
                            </li>
                            <li style={{ marginBottom: 8 }}>
                              <span style={{ fontWeight: 600 }}>
                                {' '}
                                Form 1024 (Application for Recognition of
                                Exemption Under Section 501(a) or Section 521 of
                                the Internal Revenue Code):
                              </span>{' '}
                              For other types of nonprofits.
                            </li>
                            <li style={{ marginBottom: 8 }}>
                              <Link
                                href="/tax-exempt/e-file-irs-form-990/"
                                sx={{ color: '#0202ff' }}
                              >
                                <span style={{ fontWeight: 600 }}>
                                  {' '}
                                  Form 990 (Return of Organization Exempt From
                                  Income Tax):
                                </span>
                              </Link>{' '}
                              Annual information return for tax-exempt
                              organizations.
                            </li>
                          </ul>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Container
        component="section"
        maxWidth="lg"
        sx={{ pt: 6, pb: 6, textAlign: 'center' }}
      >
        <Grid
          container
          spacing={2}
          direction={{ md: 'row', xs: 'column-reverse' }}
          sx={{ pt: 5, pb: 2 }}
        >
          <Grid
            size={{ xs: 12, sm: 6 }}
            sx={{
              textAlign: { md: 'left', xs: 'center' },
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex',
            }}
          >
            <Box
              sx={{
                px: { md: 0, sm: 0, xs: 2 },
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: { md: 'left', xs: 'center' },
              }}
            >
              {' '}
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: { md: 3, sm: 1, xs: 0 },
                  pt: { md: 0, sm: 3 },
                  textAlign: { md: 'left', sm: 'center' },
                }}
              >
                State Filing Requirements for Non-Profits
              </Typography>
              <Typography variant="body1" sx={{ mb: 1 }}>
                Nonprofit organizations play a vital role in Georgia&apos;s
                communities. To maintain transparency and accountability, the
                state mandates specific filing requirements.
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                Georgia nonprofits are primarily regulated by the Georgia
                Secretary of State and the Georgia Department of Revenue (DOR).
              </Typography>
            </Box>
          </Grid>
          <Grid
            size={{ xs: 12, sm: 6 }}
            sx={{
              textAlign: { md: 'left', sm: 'center', xs: 'center' },
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex',
            }}
          >
            <Box>
              <picture>
                <source srcSet="/assets/images/who-file-ga-img.webp" />
                <source srcSet="/assets/images/who-file-ga-img.png" />
                <img
                  src="/assets/images/who-file-ga-img.png"
                  alt="State Filing Requirements for Non-Profits"
                  className="img-responsive img-shadow"
                  loading="lazy"
                  width={500}
                  height={500}
                />
              </picture>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{
              my: { xs: 2, sm: 6, md: 8 },
              textAlign: { md: 'left', sm: 'center', xs: 'center' },
            }}
            className="MuiGrid-root-width"
          >
            <Grid
              size={12}
              sx={{
                textAlign: 'left',
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
              }}
            >
              <Paper
                variant="outlined"
                sx={{ px: 3, py: 5, borderRadius: 5, maxWidth: 800 }}
              >
                <Box>
                  <Typography
                    variant="h2"
                    sx={{
                      fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                      fontWeight: 600,
                      mb: 3,
                      textAlign: 'center',
                      lineHeight: 1.5,
                    }}
                  >
                    Key requirements include:
                  </Typography>
                  <Typography
                    component="div"
                    variant="body1"
                    sx={{ textAlign: 'center' }}
                  >
                    <Box
                      component="ul"
                      sx={{
                        listStyleType: 'none',
                        paddingLeft: 0,
                        textAlign: 'left',
                        ml: { xs: 0, sm: 3 },
                        '& li svg': { float: 'left', fontSize: 27 },
                      }}
                    >
                      <li style={{ marginBottom: 12 }}>
                        <FastForwardOutlinedIcon
                          sx={{ color: '#1da94a', mr: 1 }}
                        />
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Filing Articles of Incorporation
                        </span>
                        <br />
                        This establishes the legal existence of the nonprofit
                        corporation.
                      </li>
                      <li style={{ marginBottom: 12 }}>
                        <FastForwardOutlinedIcon
                          sx={{ color: '#1da94a', mr: 1 }}
                        />
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Annual Registration: Submission of annual
                          registration.
                        </span>
                        <br /> This keeps the state updated on the
                        organization&apos;s activities and status.
                      </li>
                      <li style={{ marginBottom: 12 }}>
                        <FastForwardOutlinedIcon
                          sx={{ color: '#1da94a', mr: 1 }}
                        />
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Charitable Organization Registration
                        </span>
                        <br /> Required registration with the Georgia Secretary
                        of State&apos;s Securities and Charities Division if
                        soliciting charitable contributions.
                      </li>
                      <li style={{ marginBottom: 12 }}>
                        <FastForwardOutlinedIcon
                          sx={{ color: '#1da94a', mr: 1 }}
                        />
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Obtaining necessary tax exemptions
                        </span>
                        <br /> This includes applying for federal tax-exempt
                        status (501(c)(3), etc.) with the IRS and subsequently
                        applying for state tax exemptions.
                      </li>
                      <li style={{ marginBottom: 12 }}>
                        <FastForwardOutlinedIcon
                          sx={{ color: '#1da94a', mr: 1 }}
                        />
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          State Employment Requirements
                        </span>
                        <br /> Compliance with state employment laws is
                        important if the organization has employees.
                      </li>
                      <li style={{ marginBottom: 12 }}>
                        <FastForwardOutlinedIcon
                          sx={{ color: '#1da94a', mr: 1 }}
                        />
                        <span style={{ fontWeight: 600 }}>
                          Registering with the Georgia Office of Charitable
                          Gaming (if applicable)
                        </span>
                        <br /> If the nonprofit engages in charitable gaming
                        activities, such as raffles or bingo, registration is
                        required.
                      </li>
                    </Box>
                  </Typography>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{
              my: { xs: 2, sm: 6, md: 8 },
              textAlign: { md: 'left', sm: 'center', xs: 'center' },
            }}
            className="MuiGrid-root-width"
          >
            <Grid
              size={12}
              sx={{
                textAlign: 'left',
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  py: 5,
                  borderRadius: 5,
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box>
                  <Typography
                    variant="h2"
                    sx={{
                      fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                      fontWeight: 600,
                      mb: 3,
                      textAlign: 'center',
                      lineHeight: 1.5,
                    }}
                  >
                    Tax Exemption Requirements
                  </Typography>
                  <Typography variant="body1" sx={{ textAlign: 'center' }}>
                    To maintain tax-exempt status in{' '}
                    <span style={{ fontWeight: 600 }}> Georgia</span>,
                    organizations must:
                  </Typography>
                  <Box
                    component="ul"
                    sx={{
                      listStyleType: 'none',
                      paddingLeft: 0,
                      textAlign: 'left',
                      ml: { xs: 0, sm: 3 },
                      '& li svg': { float: 'left', fontSize: 27 },
                    }}
                  >
                    <li style={{ marginBottom: 12 }}>
                      <FastForwardOutlinedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />
                      Submit a written request for income tax exemption to the
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        Georgia Department of Revenue
                      </span>{' '}
                      after obtaining federal 501(c)(3) status.
                    </li>
                    <li style={{ marginBottom: 12 }}>
                      <FastForwardOutlinedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />
                      Must register with the{' '}
                      <span style={{ fontWeight: 600 }}>
                        Georgia Secretary of State
                      </span>
                      , Corporations Division.
                    </li>
                    <li style={{ marginBottom: 12 }}>
                      <FastForwardOutlinedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />
                      Register with the{' '}
                      <span style={{ fontWeight: 600 }}>
                        Georgia Secretary of State, Charities Division
                      </span>{' '}
                      before soliciting contributions.
                    </li>
                    <li style={{ marginBottom: 12 }}>
                      <FastForwardOutlinedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />
                      File annual reports with the Secretary of State.
                    </li>
                    <li style={{ marginBottom: 12 }}>
                      <FastForwardOutlinedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />
                      Sales tax exemption requires an additional application
                      with the Department of Revenue.
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        // className="dotted-curve"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12} className="responsive">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Filing Deadlines for Non-Profit Forms
              </Typography>
              <Typography variant="body1" sx={{ textAlign: 'center' }}>
                Staying on top of deadlines is crucial for non-profits to avoid
                penalties or loss of good standing.
              </Typography>
            </Grid>
            <Grid size={12} className="responsive">
              {' '}
              <Typography variant="body1" sx={{ mb: 1 }}>
                Below are the key deadlines for non-profit filings in Georgia:
              </Typography>
              <Box component="div" sx={{ mb: 2 }}>
                <TableContainer
                  sx={{ border: '1px solid #828282', borderRadius: 2 }}
                >
                  <Table sx={{}} aria-label="Due Date Chart">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#ccc' }}>
                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Form
                        </TableCell>

                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,

                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Deadline
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Articles of Incorporation
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          This must be filed before establishing the nonprofit
                          entity.
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Annual Registration/Report
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Due annually between January 1st and April 1st.
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Corporate Income Tax Return
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          File by the 15th day of the 4th month after the fiscal
                          year-end if applicable.
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            backgroundColor: '#fff',
                            textAlign: 'left',
                            fontSize: 16,
                          }}
                        >
                          Form DOL-1
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          File on or before January 31st of the following year
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          IRS Form 990
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Due by the 15th day of the 5th month after the fiscal
                          year ends. Small organizations (gross receipts ≤
                          $50,000) must file Form 990-N by the 15th day of the
                          5th month. .
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>

            {/* <Grid size={12}>
              <Box component="div" sx={{ textAlign: 'center' }}>
                <Box>
                  <Button
                    variant="contained"
                    sx={{
                      mt: 4,
                      mb: 2,
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    className="btn-primary"
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=georgia`}
                  >
                    E-file State Filing
                  </Button>
                </Box>
              </Box>
            </Grid> */}
          </Grid>
        </Container>
      </Grid>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ py: 6 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
              fontWeight: 600,
              mt: 4,
              mb: 3,
              textAlign: 'center',
            }}
          >
            Registration & Annual Filing (Non-Profits)
          </Typography>
          <Typography variant="body1" sx={{ textAlign: 'center' }}>
            To operate legally as a non-profit in Georgia, organizations must
            register with the{' '}
            <Link
              href="https://sos.ga.gov/"
              target="_blank"
              sx={{ color: '#0202ff' }}
            >
              Georgia Secretary of State
            </Link>{' '}
            <Hidden smDown>
              {' '}
              <br />
            </Hidden>{' '}
            by submitting their{' '}
            <span style={{ fontWeight: 600 }}>
              {' '}
              Articles of Incorporation
            </span>{' '}
            along with a{' '}
            <span style={{ fontWeight: 600 }}>$100 filing fee.</span>
          </Typography>

          <Grid
            container
            spacing={2}
            sx={{ mt: 4, mb: 4, px: { md: 11, sm: 2, xs: 0 } }}
          >
            <Grid size={{ xs: 12, sm: 6 }} className="responsive">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  // display: 'flex',
                  // gap: 2,
                  // alignItems: 'start',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box sx={{ p: 2 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 2,
                    }}
                  >
                    Initial Registration
                  </Typography>

                  <Box component="ol" sx={{ mb: 2, '& li': { mb: 1.5 } }}>
                    <li>
                      {' '}
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        Reserve organization name:
                      </span>{' '}
                      Choose and reserve a unique name for your nonprofit with
                      the state to ensure it&apos;s available.{' '}
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        File Articles of Incorporation:
                      </span>{' '}
                      Submit your nonprofit’s formation documents to the state,
                      officially creating the organization.{' '}
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        Obtain a Federal Employer Identification Number (EIN)
                      </span>
                      Apply for an EIN from the IRS; it’s required for tax
                      filings, banking, and hiring employees.
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        Register with the Securities and Charities Division
                      </span>{' '}
                      if soliciting contributions If your nonprofit will seek
                      donations, register with the appropriate state division to
                      comply with fundraising laws.
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        Apply for state tax exemption
                      </span>{' '}
                      Submit necessary forms to qualify for exemption from state
                      income and sales taxes.{' '}
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        Register for state employment accounts
                      </span>
                      if hiring employees Set up accounts for unemployment
                      insurance, withholding tax, and workers&apos; compensation
                      if you plan to employ staff.
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }} className="responsive">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  // display: 'flex',
                  // gap: 2,
                  // alignItems: 'start',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box sx={{ p: 2 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 2,
                    }}
                  >
                    Annual Filing Requirements
                  </Typography>

                  <Box component="ol" sx={{ mb: 2, '& li': { mb: 1.5 } }}>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        File annual registration with the Secretary of State –
                      </span>{' '}
                      Submit the required annual registration to keep your
                      nonprofit active and compliant in Georgia.
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        Renew charitable organization registration (if
                        applicable) –
                      </span>{' '}
                      If your nonprofit solicits donations, renew your
                      charitable registration with the appropriate state agency.
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        Submit annual financial statements –
                      </span>{' '}
                      Provide up-to-date financial information as part of your
                      reporting obligations.{' '}
                    </li>
                    <li>
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        Maintain registered agent in Georgia –
                      </span>{' '}
                      Ensure you have a valid registered agent with a physical
                      address in Georgia to receive legal and official
                      documents.{' '}
                    </li>
                    <li>
                      Update corporate information as needed – Report any
                      changes to your nonprofit’s name, address, officers, or
                      other corporate details to the state.{' '}
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Box
        component="section"
        sx={{
          background: 'linear-gradient(90deg, #203168, #2d7a54)',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          Modern Nonprofit Filing Experience
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 2,
            lineHeight: 1.5,
          }}
        >
          TaxZerone provides nonprofits with fast, accurate, and secure e-filing
          solutions.
        </Typography>
        {/* <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=florida`}
          >
            E-File Now!
          </Button>
        </Box> */}
      </Box>
      <Container component="section" maxWidth="lg">
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 2 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
            className="responsive"
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  1. Why do I need to file state taxes and reports?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      TaxZerone is the reliable choice for employers looking for
                      accurate, efficient,
                    </Typography>
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      Filing state taxes and reports is essential for legal
                      compliance, maintaining financial credibility, claiming
                      benefits, and ensuring transparency in your organization’s
                      operations.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  2. Are churches required to register for charitable
                  solicitations in Georgia?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      <b> Yes</b>, charitable organizations in Georgia that
                      solicit or accept donations must register unless they are
                      exempt. This includes churches.
                    </Typography>
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      However, educational institutions and religious and
                      political organizations are among those exempted from this
                      requirement.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  3. Who is exempt from paying sales tax in Georgia?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      Some customers are exempt from paying sales tax under
                      Georgia law. Examples include government agencies, some
                      nonprofit organizations, and merchants purchasing goods
                      for resale.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  4. Does Georgia require a separate state income tax exemption
                  application for 501(c)(3) organizations?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      <b> No</b>, Georgia generally recognizes federal
                      tax-exempt status. All charitable organizations that
                      receive Federal 501(c)(3) tax-exempt status are exempt
                      from State taxes to the same extent.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  5. How do I know which forms I need to file?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1, mb: 1 }}>
                      The specific forms required depend on your organization’s
                      structure and activities; consult the{' '}
                      <Link
                        href="https://sos.ga.gov/"
                        target="_blank"
                        sx={{ color: '#0202ff' }}
                      >
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Georgia Secretary of State
                        </span>
                      </Link>{' '}
                      or a tax professional for guidance.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Alert severity="info" icon={false} sx={{ borderRadius: 2 }}>
                <Accordion
                  defaultExpanded
                  sx={{
                    '&.MuiAccordion-root::before, &.MuiAccordion-root.Mui-expanded::before':
                      {
                        background: 'none !important',
                      },
                    '&.MuiAccordion-root': { background: 'none !important' },
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls=""
                    id=""
                    sx={{
                      px: 0,
                      m: 0,
                      justifyContent: 'flex-start',
                      '& .MuiAccordionSummary-content, & .MuiAccordionSummary-content.Mui-expanded':
                        { m: '0 !important', flexGrow: 0 },
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: 600,
                        color: '#014361',
                        fontSize: 16,
                      }}
                    >
                      Sources and References
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails sx={{ p: 0 }}>
                    <Typography variant="body2" sx={{ mt: 1 }}>
                      This resource guide is compiled from authoritative sources
                      including:
                    </Typography>
                    <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.5 } }}>
                      <li>
                        <Link
                          href="https://sos.ga.gov/corporations-division-georgia-secretary-states-office"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Georgia Secretary of State, Corporations Division
                        </Link>
                      </li>
                      <li>
                        {' '}
                        <Link
                          href="https://sos.ga.gov/charities-division-georgia-secretary-states-office"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Georgia Secretary of State, Securities and Charities
                          Division
                        </Link>
                      </li>{' '}
                      <li>
                        {' '}
                        <Link
                          href="https://dor.georgia.gov/"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Georgia Department of Revenue (DOR)
                        </Link>
                      </li>{' '}
                      <li>
                        {' '}
                        <Link
                          href="https://www.irs.gov/charities-and-nonprofits"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          IRS Charities and Non-profits
                        </Link>
                      </li>{' '}
                      <li>
                        {' '}
                        <Link
                          href="https://www.councilofnonprofits.org/"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          National Council of Nonprofits
                        </Link>
                      </li>{' '}
                      <li>
                        {' '}
                        <Link
                          href="https://gbi.georgia.gov/services/bingo"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Georgia Office of Charitable Gaming
                        </Link>
                      </li>{' '}
                      <li>
                        {' '}
                        <Link
                          href="https://www.gabar.org/"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          State Bar of Georgia Non-profit Resources
                        </Link>
                      </li>{' '}
                    </Box>
                    <Typography variant="body2" sx={{ mb: 2 }}>
                      This resource page serves as a comprehensive guide for
                      understanding Georgia’s FTB state filing requirements for
                      non-profits, ensuring that organizations remain compliant
                      while focusing on their mission-driven work effectively.
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              </Alert>
            </Box>{' '}
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default ExemptArizona;
